import { render, staticRenderFns } from "./payment-success.component.vue?vue&type=template&id=0566a560&scoped=true"
import script from "./payment-success.component.ts?vue&type=script&lang=ts&external"
export * from "./payment-success.component.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-success.component.vue?vue&type=style&index=0&id=0566a560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566a560",
  null
  
)

export default component.exports